import { CardDetails } from "@/models/CardDetails";
import PayChoiceTokenizeApi from "./PayChoiceTokenizeApi";
import PaymentSource, {
  AdministrationPaymentSource,
} from "@/models/APIModels/PaymentSource";
import BankDetails from "@/models/BankDetails";

export default interface IPaymentTokenizeApi {
  tokenizeCard(
    cardDetails: CardDetails,
    userCategory: string,
  ): Promise<AdministrationPaymentSource>;
  tokenizeBankDetails(
    bankDetails: BankDetails,
  ): Promise<AdministrationPaymentSource>;
}

export const getPaymentTokenizer = (
  userCategory: string,
): IPaymentTokenizeApi => new PayChoiceTokenizeApi(userCategory);
